import Immutable from 'immutable';
import {
  GET_DEFAULT_PERMISSION_GROUPS_START,
  GET_DEFAULT_PERMISSION_GROUPS_SUCCESS,
  GET_DEFAULT_PERMISSION_GROUPS_FAILURE,
} from './actions';

const DEFAULT_STATE = Immutable.fromJS({
  byPagePath: {
    /*
    [pagePath]: {
      resource: {
        default: {
          isLoading: bool,
          groups: [] | null,
        },
      }
    */
  },
});

export function PermissionGroups(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case GET_DEFAULT_PERMISSION_GROUPS_START: {
      const { pagePath, resource } = action;
      return state.setIn(
        ['byPagePath', pagePath, resource, 'default', 'isLoading'],
        true
      );
    }
    case GET_DEFAULT_PERMISSION_GROUPS_SUCCESS: {
      const { pagePath, resource, groups } = action;
      return state.updateIn(
        ['byPagePath', pagePath, resource, 'default'],
        (defaultGroups) =>
          defaultGroups.merge({
            isLoading: false,
            groups: Immutable.fromJS(groups),
          })
      );
    }
    case GET_DEFAULT_PERMISSION_GROUPS_FAILURE: {
      const { pagePath, resource } = action;
      return state.updateIn(
        ['byPagePath', pagePath, resource, 'default'],
        (defaultGroups) =>
          defaultGroups.merge({
            isLoading: false,
            groups: null,
          })
      );
    }
    default: {
      return state;
    }
  }
}
